import { render } from "./EditCentralePage.vue?vue&type=template&id=115e7a34"
import script from "./EditCentralePage.vue?vue&type=script&lang=js"
export * from "./EditCentralePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__